import { shallowEqual } from 'react-redux'

export const safeShallowEqual = (left: unknown, right: unknown) => {
  let safeLeft = left
  let safeRight = right
  if (left instanceof Date) {
    safeLeft = left.getTime()
  }
  if (right instanceof Date) {
    safeRight = right.getTime()
  }

  return shallowEqual(safeLeft, safeRight)
}
